import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    FileExcelOutlined,
    FileImageOutlined,
    FileOutlined,
    FilePdfOutlined,
    FilePptOutlined,
    FileWordOutlined,
    FileZipOutlined,
    SoundOutlined,
    UploadOutlined,
    VideoCameraOutlined,
    LockOutlined,
} from '@ant-design/icons';
import { Card, Col, Row, Skeleton } from 'antd';
import fileSize from 'filesize';
import dayjs from 'dayjs';
import { Trans } from "@lingui/macro";
import BukkuTooltip from '../../Tooltip';
import { StyledCardWrapper } from '../style';
import { FilesPreview } from '../../FilesPreview';
import { FileListModule } from '../../FileUploaderListManager/enum/FileListModule';

/**
 * Props:
 * - fileItem: required {}  --- the current item to be rendered in Card
 * - selectedFileIds: required [] --- the list of selected files' id in file manager
 */
class FileCard extends Component {
    supportedImageFileFormats =
        ['gif', 'jpeg', 'jpg', 'png', 'svg', 'webp', 'cur', 'bmp']; //image

    supportedVideoFileFormats =
        ['mp4', 'mov', 'ogg', 'webm']; // video

    getFileType = item => {
        const file_extension = item.filename.substr(item.filename.lastIndexOf('.') + 1).toLowerCase();

        if (this.supportedImageFileFormats.includes(file_extension))
            return "image";

        if (this.supportedVideoFileFormats.includes(file_extension))
            return "video";

        return null;
    };

    renderPlaceholderImage = item => {
        const file_extension = item.filename.substr(item.filename.lastIndexOf('.') + 1).toLowerCase();
        if (['doc', 'docx', 'docm', 'odt'].includes(file_extension))
            return <FileWordOutlined className="file-icon" />;

        if (['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xlsb', 'ods'].includes(file_extension))
            return <FileExcelOutlined className="file-icon" />;

        if (file_extension === 'csv')
            return <FileExcelOutlined className="file-icon" />;

        if (file_extension === 'pdf')
            return <FilePdfOutlined className="file-icon" />;

        if (['ppt', 'pptx', 'pps', 'ppsx', 'ppsm', 'odp'].includes(file_extension))
            return <FilePptOutlined className="file-icon" />;

        if (['zip', 'tar', 'gzip', '7z'].includes(file_extension))
            return <FileZipOutlined className="file-icon" />;

        if (['wav', 'mp3', 'wma', 'aac', 'flac'].includes(file_extension))
            return <SoundOutlined className="file-icon" />;

        const fileType = this.getFileType(item);
        switch (fileType) {
            case 'image':
                return <FileImageOutlined className="file-icon" />;
            case 'video':
                return <VideoCameraOutlined className="file-icon" />;
            default:
                return <FileOutlined className="file-icon" />;
        }
    };

    getCreatedAtLabel = created_at => {
        if (dayjs().isSame(created_at, 'week'))
            return dayjs(created_at).format('DD MMM, ddd');
        return dayjs(created_at).format('DD MMM YYYY');
    };

    renderSkeleton = () => (
        <>
            <Col span={6} style={{ margin: 'auto' }}>
                <Skeleton.Avatar active shape="circle" />
            </Col>
            <Col span={18} className="card-skeleton--right">
                <Skeleton.Input style={{ width: '90%', height: '52px' }} active />
            </Col>
        </>
    );

    render() {
        const {
            fileItem,
            selectedFileIds,
            newlyUploadedIds,
            type,
            // redux
            deletedFileIds,
        } = this.props;

        // console.log('deletedFileIds', deletedFileIds)

        return (
            <StyledCardWrapper>
                <Card
                    //  eslint-disable-next-line no-underscore-dangle
                    hoverable={!fileItem._isSkeleton}
                    bordered
                    //  eslint-disable-next-line max-len
                    className={`file-list-card ${deletedFileIds?.includes(fileItem.id) ? ' fade-out' : ''} ${newlyUploadedIds?.includes(fileItem.id) ? ' fade-in' : ''} ${selectedFileIds.includes(fileItem.id) ? ' selected-file-card' : ''}`}
                >
                    <Row>
                        {
                            //  eslint-disable-next-line no-underscore-dangle
                            fileItem._isSkeleton ?
                                this.renderSkeleton()
                                : (
                                    <>
                                        <Col span={6} className="col__file-icon">
                                            {this.renderPlaceholderImage(fileItem)}
                                            <div
                                                className="preview-icon"
                                                onClick={e => {
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <FilesPreview
                                                    type={FileListModule.FILE_MANAGER}
                                                    record={{...fileItem, file_count: 1}}
                                                />
                                            </div>
                                        </Col>
                                        <Col span={18} className="col-card-detail">
                                            <Row>
                                                <h5 className="h5-title">
                                                    <BukkuTooltip title={fileItem.filename}>
                                                        {fileItem.filename}
                                                    </BukkuTooltip>
                                                </h5>
                                            </Row>
                                            <Row className="row-file-size">
                                                <Col className="row-file-size__col">
                                                    {fileItem.size ?
                                                        fileSize(fileItem.size, { round: 1 }) :
                                                        '-'}
                                                </Col>
                                            </Row>
                                            <Row justify="space-between">
                                                <Col className="col-uploaded">
                                                    <UploadOutlined />
                                                    &nbsp;
                                                    {this.getCreatedAtLabel(fileItem.created_at)}
                                                </Col>
                                                <Col className="col-lock-icon">
                                                    {fileItem.used_count && type === "fileManager" ?
                                                        <BukkuTooltip
                                                            title={
                                                                <Trans>
                                                                    In Use
                                                                </Trans>
                                                            }
                                                        >
                                                            <LockOutlined
                                                                onClick={e => e.stopPropagation()}
                                                            />
                                                        </BukkuTooltip>
                                                        : undefined}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>
                                )
                        }

                    </Row>
                </Card>
            </StyledCardWrapper>
        );
    }
}

export default connect(state => ({
    deletedFileIds: state.File.deletedFileIds,
}), {

})(FileCard);
